// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"fda73a07","977":"c1528a18"}[chunkId] + ".chunk.js";
};